export default "__VITE_ASSET__BiBWXHUh__"